import { RemoveRedEyeOutlined, VisibilityOff } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import TextFieldMakeAnimationStartHandler from "./TextFieldMakeAnimationStartHandler";

export interface PasswordboxProps {
    password: string;
    onEnter?: () => void;
    label?: string;
    size?: 'small' | 'medium';
    // open: boolean;
    // options: string[];
    onPasswordChange: (event: any) => void;
    classNameInput?: string;
    sx?: any;
    autofilled?: () => void;
}

export default function Passwordbox(props: PasswordboxProps) {

    const { password, onPasswordChange, onEnter, sx, label, size, classNameInput, autofilled } = props;
    const handleKeyPress = (e: any) => {
        // console.log(e);
        if (e.key === 'Enter') {
            if (onEnter)
                onEnter();
        }
    }
    const onPassChange = (event: any) => {
        // console.log(event.currentTarget.value);
        onPasswordChange(event!.currentTarget!.value);
    };

    // let [passwordState, setPasswordState] = useState("");
    let [passwordMode, setPasswordMode] = useState("password");

    const [isPasswordAutofilled, setIsPasswordAutofilled] = useState(false);
    useEffect(() => {
        if (isPasswordAutofilled && autofilled)
            autofilled();
    }, [isPasswordAutofilled, autofilled]);
    return (
        <div>
            <TextField
                className={classNameInput}
                type={passwordMode}
                variant="outlined"
                value={props.password}
                size={size ?? 'medium'}
                slotProps={{
                    htmlInput: {
                        onAnimationStart: TextFieldMakeAnimationStartHandler(setIsPasswordAutofilled),
                    },
                    inputLabel: {
                        shrink: password !== "" || isPasswordAutofilled
                    },
                    input: {
                        endAdornment:
                            <IconButton onClick={() => {
                                if (passwordMode === 'password')
                                    setPasswordMode("text");
                                else setPasswordMode("password");
                            }}> {
                                    passwordMode === 'password' ?
                                        <RemoveRedEyeOutlined /> : <VisibilityOff />
                                }</IconButton>
                    }
                }}
                sx={sx}
                onChange={onPassChange}
                id="outlined-password-input"
                label={label}
                onKeyDown={handleKeyPress}


            />
        </div>
    );
}